export const SET_SATSER = 'SET_SATSER';

export interface SetSatserAction<T> {
    type: typeof SET_SATSER;
    payload: T;
}

export type SatserActionTypes<T> = SetSatserAction<T>;
